var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaximizeMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42,41c0,0.5517578-0.4482422,1-1,1h-9v2h9c1.6542969,0,3-1.3457031,3-3v-9h-2V41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,4h-9v2h9c0.5517578,0,1,0.4482422,1,1v9h2V7C44,5.3457031,42.6542969,4,41,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,7v9h2V7c0-0.5517578,0.4482422-1,1-1h9V4H7C5.3457031,4,4,5.3457031,4,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,41v-9H4v9c0,1.6542969,1.3457031,3,3,3h9v-2H7C6.4482422,42,6,41.5517578,6,41z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeMedium);
export default __webpack_public_path__ + "static/media/maximize--medium.c9bd3ed940108ced22ee00a1bc98d2d4.svg";
export { ForwardRef as ReactComponent };